export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '9681ab5b-6bfd-409c-bc15-aa14fb1843e7';
export const MODAL_CLOSE_SEC = 2.5;
